module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eFp8M"))).then(() => parcelRequire('d0iPb'));